export enum Direction {
  left = -1,
  up = -2,
  right = 1,
  down = 2,
}

export function oppositeDirection(d: Direction) {
  return -d as Direction
}

const { left, right, up, down } = Direction

export function keyToDirection(key: string): Direction | null {
  switch (key) {
    case 'ArrowUp':
    case 'w':
      return up
    case 'ArrowLeft':
    case 'a':
      return left
    case 'ArrowDown':
    case 's':
      return down
    case 'ArrowRight':
    case 'd':
      return right
    default:
      return null
  }
}

export function directionToString(d: Direction | null | undefined): string {
  switch (d) {
    case Direction.left:
      return 'left'
    case Direction.up:
      return 'up'
    case Direction.right:
      return 'right'
    case Direction.down:
      return 'down'
    default:
      return 'none'
  }
}

export interface Snake {
  initialDirectionVertical: boolean
  jointLengths: number[] // oldest at beginning, tail to head
  jointLengthsLength: number
  head: [number, number]
  length: number
  id: string
  color: string
  name: string
  spawnTime: number
  kills: number
}
export interface DyingSnake extends Snake {
  alpha: number
}
export type Food = [number, number]
export interface Model {
  snakes: Snake[]
  food: Food[]
  dyingSnakes: DyingSnake[]
  announcement: string | null
}
export interface ServerUpdate extends Model {
  t: number
  serverId: string
}

export const foodWidth = 0.5

const size = 10
export const walls = { x: 16 * size, y: 9 * size }

export const numFood = 27
export const speed = 0.101
export const maxDistanceFromBorder = 1
export const initialLength = 9

export const allColors = [
  'blue',
  'red',
  'green',
  'orange',
  'purple',
  'white',
  'pink',
  'yellow',
  'turquoise',
]
